<template lang="pug">
  .page.page-quiz(ref="quizPage")
    Quiz
    Recruitment
</template>

<script>
import { mapState } from 'vuex';
import Quiz from '../components/Quiz.vue';
import Recruitment from '../components/Recruitment.vue';

export default {
  name: 'QuizPage',
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(['currentPage'])
  },
  methods: {
    isRecruitmentInView() {
      if (this.currentPage !== 'Quiz') return
      const { quizPage } = this.$refs;
      const logo = document.querySelector('#recruitment .section__logo');
      const elemY = logo.getClientRects()[0].y;
      if (elemY < window.innerHeight * (2 / 3)) {
        quizPage.classList.add('in');
      } else {
        quizPage.classList.remove('in');
      }
    }
  },
  mounted() {
    const { isRecruitmentInView } = this;
    isRecruitmentInView();
    window.addEventListener('resize', isRecruitmentInView);
    window.addEventListener('scroll', isRecruitmentInView);
  },
  components: {
    Quiz,
    Recruitment
  }
}
</script>

<style lang="scss">

</style>
